export const visibleFields = ["id", "active", "fullName", "email"];

export const hiddenFields = [
	"role",
	"city",
	"declarantTypeLabel",
	"connections",
];
